<template>
  <div class="photo-gallery" style="width: 100%;">
    <div class="empty-state" v-if="items.length === 0">
      <p class="empty-state-text">暂无数据</p>
    </div>
    <div class="box_2 flex-row justify-between" v-else>
      <div class="pg-group_1 flex-row" v-if="items[0]" @click="goDetail(items[0])">
        <div class="image-text_15 flex-col">
          <div class="image-wrapper_2 flex-col">
            <div class="bg-box">
              <img
                class="bg-img"
                referrerpolicy="no-referrer"
                :src="items[0].img"
              />
            </div>
          </div>
          <span class="text-group_15">{{ items[0].title }}</span>
        </div>
      </div>
      <div class="pg-group_2 flex-row" v-if="items[1]" @click="goDetail(items[1])">
        <div class="image-text_16 flex-col">
          <div class="image-wrapper_3 flex-col">
            <div class="bg-box">
              <img
                class="bg-img"
                referrerpolicy="no-referrer"
                :src="items[1].img"
              />
            </div>
          </div>
          <span class="text-group_16">{{ items[1].title }}</span>
        </div>
      </div>
    </div>
    <div class="box_8 flex-row justify-between">
      <div class="pg-group_3 flex-row" v-if="items[2]" @click="goDetail(items[2])">
        <div class="image-text_21 flex-col">
          <img
            class="image_9"
            referrerpolicy="no-referrer"
            :src="items[2].img || defaultThumb"
          />
          <span class="text-group_20">{{ items[2].title }}</span>
        </div>
      </div>
      <div class="pg-group_4 flex-row" v-if="items[3]" @click="goDetail(items[3])">
        <div class="image-text_22 flex-col">
          <img
            class="image_10"
            referrerpolicy="no-referrer"
            :src="items[3].img || defaultThumb"
          />
          <span class="text-group_21">{{ items[3].title }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PhotoGallery',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      defaultThumb: require('../assets/img/video-thumb-1.png')
    }
  },
  methods: {
    goDetail(item) {
      if (item && item.id) {
        this.$router.push('/article/' + item.id)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.box_2 {
  margin: 10px 16px 0;
  .pg-group_1,
  .pg-group_2 {
    flex: 1;
    max-width: calc(50% - 5px);
    box-shadow: 0px 2px 14px 0px rgba(204, 204, 204, 0.5);
    background-color: rgba(255, 255, 255, 1);
    border-radius: 6px;
    padding: 11px 13px 11px 12px;
    cursor: pointer;
    transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1);

    &:active {
      transform: scale(0.96);
      opacity: 0.85;
    }
  }
  .pg-group_1 {
    .image-text_15 {
      width: 100%;
      .image-wrapper_2 {
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 71.43%;
        .bg-box {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
          border-radius: 4px;
        }
        .bg-img {
          width: 100%;
        }
        .icon_9 {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 24px;
          height: 24px;
          z-index: 1;
        }
      }
      .text-group_15 {
        overflow: hidden;
        text-overflow: ellipsis;
        color: rgba(0, 0, 0, 1);
        font-size: 14px;
        text-align: right;
        white-space: nowrap;
        line-height: 18px;
        margin: 10px 0 0 0;
      }
    }
  }
  .pg-group_2 {
    .image-text_16 {
      width: 100%;
      .image-wrapper_3 {
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 71.43%;
        .bg-box {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
          border-radius: 4px;
        }
        .bg-img {
          width: 100%;
        }
        .icon_10 {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 24px;
          height: 24px;
          z-index: 1;
        }
      }
      .text-group_16 {
        overflow: hidden;
        text-overflow: ellipsis;
        color: rgba(0, 0, 0, 1);
        font-size: 14px;
        text-align: right;
        white-space: nowrap;
        line-height: 18px;
        margin: 10px 0 0 0;
      }
    }
  }
}
.box_8 {
  margin: 10px 16px 0;
  .pg-group_3 {
    box-shadow: 0px 2px 14px 0px rgba(204, 204, 204, 0.5);
    background-color: rgba(255, 255, 255, 1);
    border-radius: 6px;
    padding: 11px 13px 11px 12px;
    cursor: pointer;
    transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1);

    &:active {
      transform: scale(0.96);
      opacity: 0.85;
    }
    .image-text_21 {
      .image_9 {
        width: 140px;
        height: 100px;
      }
      .text-group_20 {
        overflow: hidden;
        text-overflow: ellipsis;
        color: rgba(0, 0, 0, 1);
        font-size: 14px;
        text-align: right;
        white-space: nowrap;
        line-height: 18px;
        margin: 10px 1px 0 5px;
      }
    }
  }
  .pg-group_4 {
    box-shadow: 0px 2px 14px 0px rgba(204, 204, 204, 0.5);
    background-color: rgba(255, 255, 255, 1);
    border-radius: 6px;
    padding: 11px 13px 11px 12px;
    cursor: pointer;
    transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1);

    &:active {
      transform: scale(0.96);
      opacity: 0.85;
    }
    .image-text_22 {
      .image_10 {
        width: 140px;
        height: 100px;
      }
      .text-group_21 {
        overflow: hidden;
        text-overflow: ellipsis;
        color: rgba(0, 0, 0, 1);
        font-size: 14px;
        text-align: right;
        white-space: nowrap;
        line-height: 18px;
        margin: 10px 1px 0 5px;
      }
    }
  }
}
</style>
